/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import * as Highcharts from 'highcharts';

import template from './exploration-table.component.html';

@Component({
  standalone: false,
  selector: 'adn-exploration-table',
  template
})
export class ExplorationTableComponent implements OnChanges {
  @Input() exploration: any;
  @Input() param: string;
  @Input() filterParam: string;
  @Input() updateFilter: (type: string, value: any) => void;

  @ViewChild('chartContainer')
  set chartContainer(chartContainer: ElementRef<HTMLElement>) {
    this.chartContainerRef = chartContainer;
    this.renderChart();
  }

  showChart = false;

  private chart: Highcharts.Chart | null = null;
  private chartContainerRef: ElementRef<HTMLElement> | null = null;

  constructor(private readonly cdr: ChangeDetectorRef) {
  }

  get rows(): any[] {
    return this.exploration?.[this.param] || [];
  }

  get statsChart(): any {
    return this.exploration?.[this.param]?.statsChart || null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.exploration || changes.param) {
      if (!this.statsChart) {
        this.destroyChart();
      } else if (this.showChart) {
        this.renderChart();
      }
      this.cdr.markForCheck();
    }
  }

  onChartTabSelected(): void {
    this.showChart = true;
    this.renderChart();
  }

  onTableTabSelected(): void {
    this.showChart = false;
  }

  addFilter(row: any): void {
    this.updateFilter?.(this.filterParam, row);
  }

  private renderChart(): void {
    if (!this.showChart || !this.chartContainerRef?.nativeElement || !this.statsChart) {
      return;
    }

    this.destroyChart();
    this.chart = Highcharts.chart(this.chartContainerRef.nativeElement, this.statsChart);
  }

  private destroyChart(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
